module.exports = __webpack_public_path__ + "static/media/funnel-dollar.d92afa75.svg";